export default __webpack_public_path__ + "static/media/bazzle_m_4.54dd04df.png";